import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgYandexMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z"
      fill="#FFCA38"
    />
    <path
      d="M31.663 25.087c-.306 2.015-.89 3.454-2.006 4.57C27.314 32 23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343-1.115-1.116-1.7-2.555-2.006-4.57L16 8l15.663 17.087Z"
      fill="#FFDC7C"
    />
    <path
      d="M.453 6.244c.33-1.671.902-2.913 1.89-3.9C4.686 0 8.458 0 16 0c7.543 0 11.314 0 13.657 2.343.988.988 1.56 2.23 1.89 3.901L18.293 19.067a3.286 3.286 0 0 1-4.586 0L.453 6.244Z"
      fill="url(#YandexMail_svg__a)"
    />
    <defs>
      <linearGradient
        id="YandexMail_svg__a"
        x1={7}
        y1={13}
        x2={22.5}
        y2={-2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F33" />
        <stop offset={1} stopColor="#FEB16F" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgYandexMail);
export default Memo;
